
import { style } from 'typestyle'

/* Styles ======================================================================================= */
import { StyleClass } from '../../../../components/style-class'

/* Types ======================================================================================== */
type ClassNames = {
  /**
   * Themed class for navContainerClass
   */
  base: string
}

type ClassProps = any

const getNames: (props: any, theme: any) => ClassNames = (props, theme) => {
  const base = style({
    width: '100%',
    background: theme.baselines.surface.medium,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    borderBottom: `1px 1px 20px 1px ${theme.boxes.shadow.medium}`,
    $nest: {
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
  })

  return {
    base,
  }
}

/* Export ======================================================================================= */
export const navContainerClass = new StyleClass<ClassNames, ClassProps>(getNames)
